import React, { useContext, useMemo, useRef, useState } from "react";
import ReactQuill from "react-quill-new";
import Attachment from "../../../../../images/Attachment.svg";
import { fileStateType, stateType } from "./Plan";
import QuillTableBetter from "quill-table-better";
import { Button } from "../../../../../stories/Button/Button";
import { Operation, empType } from "../../../../../utils/Enum.types";
import { handleUploadAndDownloadFile } from "../../../../../utils/Upload";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import { useMutation } from "@apollo/client";
import { AddPmuCommentsResult, AddPmuCommentsVars } from "../queries/types";
import { AddPmuComments } from "../queries/mutations";
import { emptyMessage } from "../../../../../utils/constants";
import { msgType } from "../../../../../utils/types";
import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import { GetMomDetails } from "../queries/query";
import { GetProjectsForMom } from "../../masters/subsidary/junctions/queries/queries";
import { Label } from "../../../../../stories/Label/Label";
import { Title } from "../../../../../stories/Title/Title";
import Cancel from "../../../../../images/Close.svg";
import MessageModal from "../../../../../customComponents/MessageModal";
import {
  FormAutocomplete,
  formClasses,
} from "../../../../../styles/AutocompleteStyles";
import { Keys } from "../../../../../utils/Enum.keys";
import { handleMUISelectEvent } from "../../../../../utils/UtilFunctions";
import { TextField } from "@mui/material";
import { AppContext } from "../../../../../context/context";
export interface Props {
  commentState: stateType;
  filesState: fileStateType;
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}
const Add = ({ commentState, filesState, setModalFlag }: Props) => {
  const messageRef = useRef<HTMLTextAreaElement | null>(null);
  const { customer_id, momID, projectID } = useUrlParams();
  const [progress, setProgress] = useState(0);
  const { state } = useContext(AppContext);

  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const quillRef = useRef<ReactQuill | null>(null);
  const { selectedFiles, setSelectedFiles } = filesState;
  const [message, setMessage] = useState<msgType>(emptyMessage);
  const [actionTaken, setActionTaken] = useState("");

  const { user_details } = useLoggedInUserDetails();
  const handleButtonClick = () => {
    fileInputRef.current?.click(); // Use optional chaining for safety
  };
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      setSelectedFiles(Array.from(event.target.files));
    }
  };
  const handleTextAreaChange = (
    value: string,
    delta: any,
    source: any,
    editor: ReactQuill.UnprivilegedEditor
  ): void => {
    commentState.setComment(value);
  };

  const modules = useMemo(
    () => ({
      toolbar: {
        container: [
          [{ header: 1 }, { header: 2 }], // custom button values
          ["bold", "italic", "underline", "strike"], // toggled buttons
          ["link", "image"],
          [{ list: "bullet" }],
          [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
          [{ direction: "rtl" }], // text direction
          [{ size: ["small", false, "large", "huge"] }], // custom dropdown
          [{ color: [] }, { background: [] }], // dropdown with defaults from theme
          [{ font: [] }],
          [{ align: [] }],
          // ['tableUI'],
          ["table-better"], // Add table tool
        ],
      },
      table: false,
      "table-better": {
        language: "en_US",
        menus: [
          "column",
          "row",
          "merge",
          "table",
          "cell",
          "wrap",
          "copy",
          "delete",
        ],
        operationMenu: {
          items: {
            insertColumnRight: true,
            insertColumnLeft: true,
            insertRowUp: true,
            insertRowDown: true,
            deleteColumn: true,
            deleteRow: true,
            deleteTable: true,
          },
        },
        toolbarTable: true,
      },
      keyboard: {
        bindings: QuillTableBetter.keyboardBindings,
      },
    }),
    []
  );

  const handleTextAreaSelect = () => {
    const selectedText = window.getSelection()?.toString();
    if (selectedText && selectedText.length > 0) {
      messageRef.current?.focus();
    }
  };

  const [AddPmu] = useMutation<AddPmuCommentsResult, AddPmuCommentsVars>(
    AddPmuComments,
    {
      onError: (e) => {
        setMessage({
          flag: true,
          message: e.message,
          operation: Operation.NONE,
        });
      },
    }
  );
  const handleSave = () => {
    if (customer_id && momID && projectID) {
      let filename = "";
      if (selectedFiles) {
        filename = selectedFiles
          .map((file, index) => {
            return `${customer_id}/momDetails/${momID}/${projectID}/${file.name}`;
          })
          .join(";");
      }

      AddPmu({
        variables: {
          customerID: customer_id!,
          momID,
          projectID,
          user_details,
          input: [
            {
              pmuComments: commentState.comment,
              pmuDocuments: filename,
              actionTaken: actionTaken,
            },
          ],
        },
        refetchQueries: [
          {
            query: GetMomDetails,
            variables: {
              customerID: customer_id,
              momID,
              projectID,
              latest: true,
            },
          },
          {
            query: GetProjectsForMom,
            variables: {
              customerID: customer_id,
              empID: user_details.id,
              momID,
              latest: true,
            },
          },
        ],
      }).then(({ data }) => {
        if (
          data &&
          data.AddPmuComments &&
          data.AddPmuComments.length &&
          data.AddPmuComments[0].id
        ) {
          if (selectedFiles) {
            const uploadFilePromise = Promise.all(
              selectedFiles.map((file, index) => {
                const fileExt = file.name.split(".").pop();
                handleUploadAndDownloadFile(
                  file,
                  `${customer_id}/momDetails/${momID}/${projectID}/${data.AddPmuComments[0].id}_${index}.${fileExt}`,
                  setProgress,
                  false
                );
              })
            );

            Promise.all([uploadFilePromise]).then(([sendMsgData]) => {
              if (sendMsgData) {
                commentState.setComment("");
                setSelectedFiles([]);
                setMessage({
                  flag: true,
                  message: "Comment added successfully",
                  operation: Operation.CREATE,
                });
              }
            });
          }
        }
      });
    }
  };

  const handleClear = () => {
    commentState.setComment("");
    setActionTaken("");
  };
  const handleClose = () => {
    if (message.flag && message.operation !== Operation.NONE) {
      handleClear();
    }
    setMessage(emptyMessage);
  };

  return (
    <div className="plan-meeting__add-new">
      <div className="plan-meeting__add-new--title">
        <Title>Add New Minutes of Meeting Points</Title>
        <img src={Cancel} alt="" onClick={() => setModalFlag(false)} />
      </div>
      <div className="plan-meeting__add-new--block">
        <Label>
          Description{" "}
          <img
            src={Attachment}
            onClick={handleButtonClick}
            alt=""
            style={{ width: "20px", height: "20px" }}
          />
        </Label>
        <div>
          <input
            type="file"
            ref={fileInputRef}
            onChange={handleFileChange}
            style={{ display: "none" }} // Hide the default file input
            multiple
          />
          {selectedFiles.length > 0 && (
            <>
              {selectedFiles.map((file, index) => (
                <span key={index}>{`${file.name}`}</span>
              ))}
            </>
          )}
        </div>

        <div className="plan-meeting__add-new--block">
          <div className="plan-meeting__add-new--block--quill">
            <ReactQuill
              ref={quillRef}
              theme={"snow"}
              value={commentState.comment}
              onChange={handleTextAreaChange}
              modules={modules}
              // formats={formatOptions}
              onChangeSelection={handleTextAreaSelect}
            />
          </div>
          {state.empSubType === empType.PMU && (
            <>
              <Label>Action to be Taken</Label>
              <FormAutocomplete
                className={formClasses.inputRoot}
                options={["vendor", "pmu"]}
                onKeyDown={(e) => {
                  if (e.key === Keys.ENTER) {
                    e.preventDefault();
                    handleMUISelectEvent(e);
                  }
                }}
                value={actionTaken}
                onChange={(e, newValue) => {
                  if (newValue) {
                    setActionTaken(newValue as string);
                  } else {
                    setActionTaken("");
                  }
                }}
                openOnFocus
                forcePopupIcon
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    className={formClasses.formControlRoot}
                  />
                )}
              />
            </>
          )}
        </div>
      </div>
      <Button
        mode="save"
        onClick={handleSave}
        disabled={commentState.comment ? false : true}
      />
      <Button
        mode="clear"
        onClick={handleClear}
        disabled={commentState.comment ? false : true}
      />
      <Button mode="cancel" onClick={() => setModalFlag(false)} />
      <MessageModal
        handleClose={handleClose}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
    </div>
  );
};

export default Add;
